<template>
    <div>
        <div v-if="passed_filter">
            <div class="designeroption" data-designer-component-id="measurements">
                <h3>
                  Measurements
                  <designer-question-popup-info
                    popup_info_title_html="Choosing odd leg profile? <span class='txt-positive'>Click here.</span>"
                    popup_info_inner_html="<img src='https://tranquility-dev.s3.eu-west-2.amazonaws.com/fabricator_uploads/13/odd-leg-measuring.jpg' class='full-width'>"
                  ></designer-question-popup-info>
                </h3>
                <div class="stylesoption">
                    <div :class="['form-group', !valid_door ? 'has-error' : '']">
                        <label :class="[!valid_door ? 'text-danger' : '']">Finished {{ item }} Width x Height</label>
                        <span :class="[!valid_door_width ? 'text-danger' : '']">{{ door_width }}mm</span> x <span :class="[!valid_door_height ? 'text-danger' : '']">{{ door_height }}mm</span>
                    </div>
                    <div v-for="measurement in measurements"
                         :class="['form-group mt-6', localTarget[measurement.slug] === undefined || localTarget[measurement.slug] > limits[measurement.slug].max || localTarget[measurement.slug] < limits[measurement.slug].min ? 'has-error' : 'has-success']">
                        <label :for="component_id + '_' + measurement.slug">
                            {{ updateTitle(measurement.title) }}
                          <span v-if="measurement.slug === 'flag_height' && (frameId === 5 || frameId === 8 || frameId === 11)">
                            (not including top box)
                          </span>
                            <template v-if="loading">(Checking Min/Max...)</template>
                            <template v-if="!loading">({{ limits[measurement.slug].min }}mm to {{ limits[measurement.slug].max }}mm)</template>
                        </label>
                        <input :dusk="measurement.slug" :id="component_id + '_' + measurement.slug" type="number" v-model="localTarget[measurement.slug]" class="form-control"
                               :placeholder="measurement.title" min="{{ limits[measurement.slug].min }}" max="{{ limits[measurement.slug].max }}" pattern="[0-9]" @keydown="filterKey" @input="filterInput">
                        <input v-model="localTarget['slab_width']" type="hidden" />
                        <em v-if="show_message(measurement.slug, this.frameId)" class="txt-sm txt-light">
                            {{ show_message(measurement.slug, this.frameId) }}
                        </em>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import DesignerQuestionMeasurements from "../DesignerQuestionMeasurements.vue";

    export default {
        mixins: [
            DesignerQuestionMeasurements
        ],
        methods: {
            show_message(slug, frame) {
                if (slug === 'right_width' || slug === 'left_width') {
                    return 'Including coupler';
                }
                if (slug === 'side_transom_drop') {
                    return '(excludes any addons)';
                }
                return false;
            },
            updateTitle(title){
                if(this.doorRange == 120){
                    return title.replace('Overall', 'Slab');
                }
                return title;
            }
        },
        computed: {
            item(){
                return this.doorRange != 120 ? "Door" : "Slab";
            },
            slabWidth(){
                if(this.option_list === null) {
                    return null;
                }

                return this.option_list.slab_width;
            },
            cache_key(){
                return '_' + this.fabricator
                    + '_' + this.slab
                    + '_' + this.externalColour
                    + '_' + this.internalColour
                    + '_' + this.frameProfile
                    + '_' + this.threshold
                    + '_' + this.hardwareLock
                    + '_' + this.hardwareHinge
                    + '_' + this.hardwareHandle
                    + '_' + this.hardwareKnocker
                    + '_' + this.hardwareSpyHole
                    + '_' + this.hardwareEscutcheon
                    + '_' + this.hardwareLetterbox
                    + '_' + this.hardwareLetterboxPosition
                    + '_' + this.frameId
                    + '_' + JSON.stringify(this.addons)
                    + '_' + this.cill
                    + '_' + JSON.stringify(this.filteredSidePanels)
                    + '_' + this.doorRange
                    + '_' + this.overallWidth;
            },
            url(){
                return '/api/options/' + this.fabricator + '/measurements?slab=' + this.slab
                    + '&external_colour=' + this.externalColour
                    + '&door_colour_internal=' + this.internalColour
                    + '&profile=' + this.frameProfile
                    + '&threshold=' + this.threshold
                    + '&hardware_lock=' + this.hardwareLock
                    + '&hardware_hinge=' + this.hardwareHinge
                    + '&hardware_handle=' + this.hardwareHandle
                    + '&hardware_knocker=' + this.hardwareKnocker
                    + '&hardware_spy_hole=' + this.hardwareSpyHole
                    + '&hardware_escutcheon=' + this.hardwareEscutcheon
                    + '&hardware_letterbox=' + this.hardwareLetterbox
                    + '&hardware_letterbox_position=' + this.hardwareLetterboxPosition
                    + '&frame_style=' + this.frameId
                    + '&addons=' + encodeURIComponent(JSON.stringify(this.addons))
                    + '&cill=' + this.cill
                    + '&side_panels=' + encodeURIComponent(JSON.stringify(this.filteredSidePanels))
                    + '&door_range=' + this.doorRange
                    + '&overall_width=' + this.overallWidth;
            },
            filteredSidePanels(){

                let side_panels = JSON.parse(JSON.stringify(this.sidePanels));

                let valid_properties = {};

                valid_properties.left = side_panels.left;
                valid_properties.right = side_panels.right;
                valid_properties.left_composite_id = side_panels.left_composite_id;
                valid_properties.right_composite_id = side_panels.right_composite_id;

                return valid_properties;
            },
        },
        props: {
            overallWidth: {
                required: true,
            },
        },
        watch: {
            'overallWidth': {
                handler: function (val, oldVal) {
                    this.update_options();
                },
            },
        }
    }
</script>
